<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="标题" prop="title" >
        <a-input :maxLength="5" v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="封面图" prop="coverImg" >
        <file-upload type="image" :defaultList="form.coverImgArr" :count="1"
                     @input="getImg($event, 'coverImg')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="背景图" prop="bgImage" >
        <file-upload type="image" :defaultList="form.bgImageArr" :count="1"
                     @input="getImg($event, 'bgImage')"></file-upload>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTime, addTime, updateTime } from '@/api/tree/time'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        title: null,
        coverImg:null,
        coverImgArr:[],
        coverImgCount:1,
        bgImage: null,
        bgImageArr:[],
        bgImageCount:1,
        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        coverImg: [
          { required: true, message: '封面图不能为空', trigger: 'blur' }
        ],
        bgImage: [
          { required: true, message: '背景图不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },


    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        coverImg:null,
        coverImgArr:[],
        coverImgCount:1,
        bgImage: null,
        bgImageArr:[],
        bgImageCount:1,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTime({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this;
        if(this.form.coverImg){
          this.form.coverImgArr = []
          this.form.coverImgArr.push({
            uid: guid(8, 10),
            name: that.form.coverImg,
            status: 'done',
            halfUrl: that.form.coverImg,
            url: that.form.coverImg,
            path: that.form.coverImg
          })
        }
        if(this.form.bgImage){
          this.form.bgImageArr = []
          this.form.bgImageArr.push({
            uid: guid(8, 10),
            name: that.form.bgImage,
            status: 'done',
            halfUrl: that.form.bgImage,
            url: that.form.bgImage,
            path: that.form.bgImage
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTime(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addTime(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
